// Reativar pessoa (28/09/2026): apaga a data de saída, devolve os perfis que
// ela tinha ao sair e libera o login. Admissão nova é opcional (quem volta
// depois de meses recomeça a contar férias na data nova).
import { useEffect, useState } from 'react';
import { DatePicker, Flex, Input, Modal, Typography, App as AntApp } from 'antd';
import dayjs from 'dayjs';
import { acaoPessoa, fmtData } from './apiPessoas';

const { Text } = Typography;

export default function ModalReativarPessoa({ aberto, pessoa, onClose, onSalvo }: {
  aberto: boolean;
  pessoa: { id: string; nome: string; usuario_email?: string | null; desligamento?: string | null };
  onClose: () => void;
  onSalvo: (r: any) => void;
}) {
  const { message } = AntApp.useApp();
  const [admissao, setAdmissao] = useState<string>('');
  const [senha, setSenha] = useState('');
  const [salvando, setSalvando] = useState(false);
  useEffect(() => { if (aberto) { setAdmissao(''); setSenha(''); } }, [aberto]);

  async function confirmar() {
    setSalvando(true);
    try {
      const r = await acaoPessoa('pessoa_reativar', { profissional_id: pessoa.id, admissao: admissao || undefined, senha_temp: senha || undefined });
      onSalvo(r);
    } catch (e: any) { message.error(e.message, 8); }
    finally { setSalvando(false); }
  }

  return (
    <Modal open={aberto} onCancel={() => !salvando && onClose()} onOk={confirmar} confirmLoading={salvando}
      okText="Reativar" cancelText="Voltar" title={`Reativar ${pessoa.nome}`}
      width="94vw" style={{ maxWidth: 560, top: 24 }} destroyOnHidden>
      <Flex vertical gap={10} style={{ marginTop: 8 }}>
        <Text>
          {pessoa.desligamento ? `Saiu em ${fmtData(pessoa.desligamento)}. ` : ''}
          A ficha volta a ficar ativa, os perfis de acesso que ela tinha ao sair voltam
          {pessoa.usuario_email ? ' e o login é liberado.' : '. Esta ficha não tem login — depois use "Vincular login".'}
        </Text>
        <div>
          <Text type="secondary" style={{ fontSize: 12 }}>Nova data de admissão (opcional — em branco mantém a original)</Text>
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" value={admissao ? dayjs(admissao) : null}
            onChange={(d) => setAdmissao(d ? d.format('YYYY-MM-DD') : '')} />
        </div>
        {pessoa.usuario_email && (
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>Senha temporária nova (opcional)</Text>
            <Input value={senha} onChange={(e) => setSenha(e.target.value)} placeholder="Em branco = a pessoa usa a senha que tinha" />
          </div>
        )}
      </Flex>
    </Modal>
  );
}
